var map = {
	"./bh-ico.svg": 791,
	"./bonus-ico.svg": 792,
	"./deposit-ico.svg": 793,
	"./deposit-ico.webp": 1829,
	"./edit-icon.svg": 794,
	"./fb-ico.svg": 795,
	"./instant-rebate-ico.svg": 796,
	"./mall-ico.svg": 797,
	"./msg-ico.svg": 798,
	"./pi-ico.svg": 799,
	"./rf-ico.svg": 800,
	"./rh-ico.svg": 801,
	"./th-ico.svg": 802,
	"./vip-ico.svg": 803,
	"./withdrawal-ico.svg": 804,
	"./withdrawal-ico.webp": 1830,
	"./wl-ico.svg": 805
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1828;